//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HHeader',
  props: {
    proportion: {
      // slot left/center/right 横向面积比例
      type: Array,
      default: () => [1, 2, 1],
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/HHeader/index.vue